// components/index.js

export { default as header } from "./header";
export { default as footer } from "./footer";
export { default as main } from "./main";
export { default as nav } from "./nav";
